import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

export default function StudentRegistration() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", mobile: "", email: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);

  // Auto-close welcome popup after 4 seconds
  useEffect(() => {
    const timer = setTimeout(() => setShowWelcome(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  const validate = () => {
    const errs = {};
    if (!form.name.trim() || form.name.trim().length < 2)
      errs.name = "Please enter your full name (min 2 characters)";
    if (!/^[6-9]\d{9}$/.test(form.mobile))
      errs.mobile = "Enter a valid 10-digit Indian mobile number";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      errs.email = "Enter a valid email address";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    sessionStorage.setItem("student", JSON.stringify({
      name: form.name.trim(),
      mobile: form.mobile.trim(),
      email: form.email.trim().toLowerCase(),
      startedAt: new Date().toISOString()
    }));
    setTimeout(() => navigate("/quiz"), 500);
  };

  const secs = [
    { icon: "🌐", label: "HTML & CSS", count: "10 Questions" },
    { icon: "🧠", label: "Reasoning", count: "5 Questions" },
    { icon: "📊", label: "Aptitude", count: "5 Questions" },
    { icon: "💻", label: "C Programming", count: "10 Questions" },
  ];

  return (
    <div className="page-wrapper">

      {/* ── Calm Welcome Popup ─────────────────────────────────────────── */}
      {showWelcome && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(0,0,0,0.72)",
          backdropFilter: "blur(10px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 20,
          animation: "fadeIn 0.6s ease"
        }}>
          <div style={{
            background: "linear-gradient(160deg, #0f172a 0%, #1e1b4b 100%)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 28,
            padding: "44px 40px",
            maxWidth: 460,
            width: "100%",
            textAlign: "center",
            boxShadow: "0 30px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(124,58,237,0.2)",
            animation: "slideUp 0.5s cubic-bezier(0.34,1.56,0.64,1)"
          }}>
            {/* SVMC Logo */}
            <div style={{
              width: 90, height: 90,
              borderRadius: "50%",
              background: "white",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 20px",
              padding: 8,
              boxShadow: "0 8px 32px rgba(124,58,237,0.3)"
            }}>
              <img
                src="https://svmcautonomous.ac.in/assets/images/logo-svm.png"
                alt="SVMC"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                onError={e => {
                  e.target.style.display = "none";
                  e.target.parentElement.innerHTML = `<span style="font-size:2rem">🏫</span>`;
                }}
              />
            </div>

            {/* College name */}
            <p style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "2px",
              textTransform: "uppercase",
              color: "#a78bfa",
              marginBottom: 10,
              fontFamily: "'Poppins',sans-serif"
            }}>
             Swami Vivekananda Memorial Autonomous College
            </p>

            {/* Welcome heading */}
            <h2 style={{
              fontFamily: "'Poppins',sans-serif",
              fontWeight: 800,
              fontSize: "1.7rem",
              color: "#f9fafb",
              marginBottom: 14,
              lineHeight: 1.2
            }}>
              Welcome! 🙏
            </h2>

            {/* Calm message */}
            <p style={{
              color: "#94a3b8",
              fontSize: "0.95rem",
              lineHeight: 1.75,
              marginBottom: 24,
              fontFamily: "'Poppins',sans-serif",
              fontWeight: 400
            }}>
              Take a deep breath and relax.<br />
              This assessment is an opportunity to show<br />
              what you know. <strong style={{ color: "#c4b5fd" }}>You've got this!</strong>
            </p>

            {/* Divider */}
            <div style={{
              height: 1,
              background: "linear-gradient(90deg, transparent, rgba(167,139,250,0.3), transparent)",
              marginBottom: 20
            }} />

            {/* Info pills */}
            <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap", marginBottom: 28 }}>
              {["📝 30 Questions", "⏱ 20 Minutes", "✅ Submit Once"].map(t => (
                <span key={t} style={{
                  padding: "5px 14px",
                  borderRadius: 20,
                  background: "rgba(167,139,250,0.12)",
                  border: "1px solid rgba(167,139,250,0.25)",
                  color: "#c4b5fd",
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  fontFamily: "'Poppins',sans-serif"
                }}>{t}</span>
              ))}
            </div>

            {/* CTA button */}
            <button
              onClick={() => setShowWelcome(false)}
              style={{
                width: "100%",
                padding: "14px",
                background: "linear-gradient(135deg, #7c3aed, #00d4ff)",
                border: "none",
                borderRadius: 14,
                color: "white",
                fontFamily: "'Poppins',sans-serif",
                fontWeight: 700,
                fontSize: "1rem",
                cursor: "pointer",
                letterSpacing: "0.5px",
                transition: "opacity 0.2s",
              }}
              onMouseEnter={e => e.target.style.opacity = "0.88"}
              onMouseLeave={e => e.target.style.opacity = "1"}
            >
              I'm Ready — Let's Begin →
            </button>

            {/* Auto-close hint */}
            <p style={{ marginTop: 12, fontSize: "0.72rem", color: "#475569", fontFamily: "'Poppins',sans-serif" }}>
              This message closes automatically in a few seconds
            </p>
          </div>
        </div>
      )}

      {/* ── Header ────────────────────────────────────────────────────────── */}
      <Header subtitle="Assessment Portal" />

      {/* ── SVMC Banner ───────────────────────────────────────────────────── */}
      <div style={{
        background: "linear-gradient(135deg, rgba(124,58,237,0.08) 0%, rgba(0,212,255,0.05) 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        padding: "20px 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 18
      }}>
        {/* SVMC Logo small */}
        <div style={{
          width: 52, height: 52,
          borderRadius: "50%",
          background: "white",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 5,
          flexShrink: 0,
          boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
        }}>
          <img
            src="https://svmcautonomous.ac.in/assets/images/logo-svm.png"
            alt="SVMC Logo"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={e => { e.target.style.display = "none"; }}
          />
        </div>

        <div>
          <p style={{
            fontFamily: "'Poppins',sans-serif",
            fontWeight: 700,
            fontSize: "1rem",
            color: "#f9fafb",
            marginBottom: 2
          }}>
Swami Vivekananda Memorial Autonomous College
          </p>
          <p style={{
            fontFamily: "'Poppins',sans-serif",
            fontSize: "0.78rem",
            color: "#9ca3af",
            display: "flex", alignItems: "center", gap: 6
          }}>
            <span style={{
              display: "inline-block", width: 6, height: 6,
              borderRadius: "50%", background: "#10b981"
            }} />
            Autonomous Technical Campus Drive  — Powered by HyperDigiTech
          </p>
        </div>
      </div>

      {/* ── Hero ──────────────────────────────────────────────────────────── */}
      <div className="hero">
        <h1>Technical Assessment</h1>
        <p>Complete the registration below to begin your 30-question assessment across 4 technical domains.</p>
      </div>

      {/* ── Section cards ─────────────────────────────────────────────────── */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, maxWidth: 700, margin: "0 auto 32px", padding: "0 20px" }}>
        {secs.map(s => (
          <div key={s.label} style={{
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 14, padding: "16px 20px",
            display: "flex", alignItems: "center", gap: 12
          }}>
            <span style={{ fontSize: "1.5rem" }}>{s.icon}</span>
            <div>
              <div style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 600, fontSize: "0.9rem" }}>{s.label}</div>
              <div style={{ fontSize: "0.78rem", color: "var(--muted)" }}>{s.count}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Registration form ──────────────────────────────────────────────── */}
      <div style={{ maxWidth: 480, margin: "0 auto", padding: "0 20px 60px" }}>
        <div className="glass-card">
          <div style={{ marginBottom: 28 }}>
            <h2 style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 700, fontSize: "1.25rem", marginBottom: 6 }}>
              Student Registration
            </h2>
            <p style={{ color: "var(--muted)", fontSize: "0.88rem" }}>
              Fill in your details to begin. All fields are required.
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input className="form-input" type="text" placeholder="e.g. Rahul Kumar" value={form.name}
                onChange={e => { setForm({ ...form, name: e.target.value }); setErrors({ ...errors, name: "" }); }} />
              {errors.name && <p style={{ color: "var(--danger)", fontSize: "0.78rem", marginTop: 5 }}>{errors.name}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Mobile Number</label>
              <input className="form-input" type="tel" placeholder="e.g. 9876543210" maxLength={10} value={form.mobile}
                onChange={e => { setForm({ ...form, mobile: e.target.value.replace(/\D/, "") }); setErrors({ ...errors, mobile: "" }); }} />
              {errors.mobile && <p style={{ color: "var(--danger)", fontSize: "0.78rem", marginTop: 5 }}>{errors.mobile}</p>}
            </div>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input className="form-input" type="email" placeholder="e.g. rahul@example.com" value={form.email}
                onChange={e => { setForm({ ...form, email: e.target.value }); setErrors({ ...errors, email: "" }); }} />
              {errors.email && <p style={{ color: "var(--danger)", fontSize: "0.78rem", marginTop: 5 }}>{errors.email}</p>}
            </div>
            <button className="btn-primary" type="submit" disabled={loading}>
              {loading ? "Starting..." : "Start Assessment →"}
            </button>
          </form>
          <p style={{ textAlign: "center", marginTop: 16, fontSize: "0.78rem", color: "var(--muted)" }}>
            ⏱ 20 min timer · 30 questions · Submit once
          </p>
        </div>

        {/* Footer credit */}
        <div style={{ textAlign: "center", marginTop: 24, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
          <img
            src="https://hyperdigitech.com/assets/logo-De65uxdz.webp"
            alt="HyperDigiTech"
            style={{ height: 22, objectFit: "contain", opacity: 0.7 }}
            onError={e => { e.target.style.display = "none"; }}
          />
          <span style={{ fontSize: "0.72rem", color: "#475569", fontFamily: "'Poppins',sans-serif" }}>
            Powered by HyperDigiTech
          </span>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes slideUp {
          from { transform: translateY(40px) scale(0.95); opacity: 0; }
          to   { transform: translateY(0)    scale(1);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}